import { format } from "date-fns";
import { isValidDate } from "@/utils/dateUtils";

// "1948 – 29.01.2024": birth year, then the full death date.
export function defaultCardDates(obituary) {
  if (!obituary) return "";
  const birth =
    obituary.birthYear != null ? String(obituary.birthYear)
    : isValidDate(obituary.birthDate) ? format(new Date(obituary.birthDate), "yyyy")
    : "";
  const death =
    isValidDate(obituary.deathDate) ? format(new Date(obituary.deathDate), "dd.MM.yyyy")
    : obituary.deathYear != null ? String(obituary.deathYear)
    : "";
  return [birth, death].filter(Boolean).join(" – ");
}

/**
 * The obituary the card on top of a message shows. What the author changed in step 2 wins;
 * a field left as null falls back to the obituary itself, an empty string shows nothing.
 * The card keeps its standard look (dates as years only, candle counter, ...) unless the author
 * changed that field.
 */
export function buildCardData(message) {
  const obituary = message.Obituary ?? {};
  return {
    ...obituary,
    location: message.cardLocation ?? obituary.location,
    image: message.cardImage ?? obituary.image,
    symbol: message.cardSymbol ?? obituary.symbol,
    datesText: message.cardDates ?? undefined,
  };
}

// Every religious symbol the card can draw. Ids 1-5 are the ones the memory page already uses;
// 6 (praying hands) is new, from the design of the "add message" popup.
export const SYMBOL_IMAGES = {
  "1": { src: "/icon_cross.png", label: "Križ" },
  "2": { src: "/img_plus2.png", label: "Okrašeni križ" },
  "3": { src: "/img_moon_star.png", label: "Polmesec in zvezda" },
  "4": { src: "/img_plus3.png", label: "Križ s poševno prečko" },
  "5": { src: "/img_star.png", label: "Davidova zvezda" },
  "6": { src: "/icon_hands.png", label: "Sklenjene roke" },
};

// The four symbols the popup offers, in the order of the design.
export const OFFERED_SYMBOL_IDS = ["1", "2", "3", "6"];
